module.exports = require("admin/components/modal/scrub-rejected-user");